import Vue from "vue";
import { v4 as uuidv4 } from "uuid";

const icons = {
    error: "exclamation-circle",
    success: "thumbs-up",
    info: "flag",
    warning: "exclamation-triangle"
};

const initialConfirm = {
    info: {
        title: null,
        content: null, // html
        onConfirm: null,
        onCancle: null
    },
    options: {
        isCancle: true, // 취소 가능 여부
        buttonText: {
            confirm: "확인",
            cancle: "취소"
        }
    }
};

export const state = Vue.observable({
    alerts: [],

    confirm: {
        toggle: false,
        info: {
            title: null,
            content: null, // html
            onConfirm: null,
            onCancle: null
        },
        options: {
            isCancle: true, // 취소 가능 여부
            buttonText: {
                confirm: "확인",
                cancle: "취소"
            }
        }
    }
});

export const mutations = {
    pushAlert({ type, message }) {
        const uid = uuidv4();
        const icon = icons[type] || "bell";

        state.alerts.unshift({ uid, type, message, icon });
    },

    removeAlert(uid) {
        const index = state.alerts.findIndex(v => v.uid === uid);
        state.alerts.splice(index, 1);
    },

    openConfirm(info, options) {
        state.confirm.toggle = true;

        state.confirm.info = { ...state.confirm.info, ...info };
        state.confirm.options = { ...state.confirm.options, ...options };
    },

    closeConfirm() {
        state.confirm.toggle = false;

        setTimeout(() => {
            state.confirm.info = initialConfirm.info;
            state.confirm.options = initialConfirm.options;
        }, 350);
    }
};
